(() => {
  if (customElements.get('hero-slider')) {
    return;
  }

  class HeroSlider extends HTMLElement {
    constructor() {
      super();

      this.slider = {};
      this.controls = this.querySelectorAll('[data-control]');

      this.viewportWidth = window.innerWidth;
      [
        'shopify:section:load',
        'load',
        'resize'
      ].forEach((event) => {
        window.addEventListener(event, () => {
          if (event == 'resize' && window.innerWidth == this.viewportWidth) return;
          this.viewportWidth = window.innerWidth;
          this.calcHeight();
        });
      });
    }

    connectedCallback() {

      const autoplayEnabled = this.dataset.autoplay === 'true';

      this.slider = new Swiper(this, {
        loop: Number(this.dataset.slidesCount) > 1,
        effect: Number(this.dataset.slidesCount) > 1 ? 'slide' : 'fade',
        preventClicks: false,
        autoplay: autoplayEnabled ? {
          delay: Number(this.dataset.autoplayInterval),
          disableOnInteraction: false,
        } : false,
        navigation: {
          nextEl: '.hero__arrow-next',
          prevEl: '.hero__arrow-prev',
        },
        on: {
          init: () => {
            this.addAnimationHanler();
            this.updateImageClasses();
          },
          slideChange: () => {
            this.addFadeAnimations();
            this.hydrateDeferredImages();
          },
        },
      });

      // Slides 2..n defer their srcset until load (see hero.liquid), so letting
      // autoplay run during the initial paint advances onto an image that has not
      // been fetched yet — that slide becomes the LCP element and lands seconds
      // late. Hold autoplay until hydrateDeferredImages() promotes the srcsets.
      if (autoplayEnabled) this.slider.autoplay.stop();

      // Slides after the first ship their srcset as data-srcset (see hero.liquid)
      // so they stop competing with the LCP image for bandwidth. Promote them
      // once the page has loaded, or sooner if the visitor swipes first.
      if (document.readyState === 'complete') {
        this.hydrateDeferredImages();
      } else {
        window.addEventListener('load', () => this.hydrateDeferredImages(), { once: true });
      }
    }

    hydrateDeferredImages() {
      this.querySelectorAll('[data-srcset]').forEach((element) => {
        element.srcset = element.dataset.srcset;
        element.removeAttribute('data-srcset');
        // Swiper moves slides with a transform, and Chrome will not re-run its
        // native lazy check for an image that arrives at a srcset afterwards —
        // the off-screen slides simply never fetched. Hydration already happens
        // after load, so eager is what we want by the time we get here.
        if (element.tagName === 'IMG') element.loading = 'eager';
      });

      if (this.dataset.autoplay === 'true') this.slider?.autoplay?.start();
    }

    addAnimationHanler() {
      this.querySelectorAll('[data-fade-in]')?.forEach((element) => {
        element.addEventListener('animationend', () => {
          this.addFadeAnimations();
        })
      })
    }

    updateImageClasses() {
      this.querySelectorAll('.lazyloading')?.forEach(lazyloadImage => {
        lazyloadImage.classList.remove('lazyloading')
        lazyloadImage.classList.add('lazyloaded')
      })
    }

    addFadeAnimations() {
      this.animatedElements = this.querySelectorAll('[data-fade-in]');
      this.animatedElements.forEach((element) => {
        element.classList.add('fade-in');
      })
    }

    calcHeight() {
      // Subtract only what sits above the page content. The home header floats
      // over the hero, so counting its height as well left the hero one header
      // short of the screen and cropped the bottom of the banner. Where the
      // header is not transparent, <main> starts below it and this still holds.
      const main = document.querySelector('main');
      const headerOffset = main
        ? Math.max(0, Math.round(main.getBoundingClientRect().top + window.scrollY))
        : 0;

      this.querySelectorAll('.hero__block').forEach((element) => {
        const heroHeight = element.dataset.heroHeight;
        element.style.height =
          window.innerWidth > 989
            ? 'auto'
            : `calc(${heroHeight}vmax - ${headerOffset}px)`;
      });
    }
  }

  customElements.define('hero-slider', HeroSlider);
})();
